import { ROUTE_PATH as BRANDS_PAGE_PATH } from '@/features/brandsPage/consts';

export const ROUTE_PATH = `${BRANDS_PAGE_PATH}/:brandId/edit`;

export const FEATURE_NAME = 'brandEditPage';
